import type { SerializedError } from '@reduxjs/toolkit';
import type { FetchBaseQueryError } from '@reduxjs/toolkit/query';

import type { PropsWithChildren } from 'react';
import type { ApiResponseError } from '@/lib/api';
import type ErrorResponse from './ErrorResponse';

export interface FetchBaseQueryAlertProps extends PropsWithChildren {
	error: ApiResponseError | FetchBaseQueryError | SerializedError | undefined;
	title?: string;
}

export const FetchBaseQueryAlert = ({ error, title, children }: FetchBaseQueryAlertProps) => {
	if (error) {
		if (Object.hasOwn(error, 'message')) {
			return (
				<div className="alert">
					{title} {(error as SerializedError).message}
					{children}
				</div>
			);
		}

		const errorData = (error as FetchBaseQueryError).data;

		if (errorData) {
			const message = (errorData as ErrorResponse).message;

			if (message) {
				return (
					<div className="alert">
						<h3>{title}</h3>
						{(errorData as ErrorResponse).message}
						{children}
					</div>
				);
			}
		}

		if ('error' in error && error.error) {
			return (
				<div className="alert">
					<h3>{title}</h3>
					{error.error}
					{children}
				</div>
			);
		}
	}

	return (
		<div className="alert">
			<h3>{title}</h3>
			{children}
		</div>
	);
};

export default FetchBaseQueryAlert;
